import { ChangeDetectionStrategy, Component, output, signal, ViewEncapsulation } from '@angular/core';
import { ClickOutsideDirective } from '@shared/click-outside/click-outside.directive';
import { ChevronComponent } from '@shared/chevron/chevron.component';
import { CurrencyItems } from '@content/pricing/pricing-plans/price-dropdown/price-dropdown.const';

@Component({
    selector: 'companyid-price-dropdown',
    imports: [ClickOutsideDirective, ChevronComponent],
    templateUrl: './price-dropdown.component.html',
    styleUrl: './price-dropdown.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceDropdownComponent {
    public title = signal<string>(CurrencyItems.USD);
    public onChangeCurrency = output<string>();
    public isShown = signal<boolean>(false);
    public readonly currencyItems: string[] = Object.values(CurrencyItems);

    public toggle(): void {
        this.isShown.set(!this.isShown());
    }

    public changeCurrency(item: string): void {
        this.onChangeCurrency.emit(item);
        this.title.set(item);
        this.toggle();
    }
}
